import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from '@mui/icons-material';
import WishlistStore from '../DataRepo/WishlistStore';
import { CircularProgress } from '@mui/material';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import { IconButton, Button } from '@mui/material';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import loadingimg from '../Assets/images/loading image 1.png'
import nofav from '../Assets/images/No favourite vector.png'
import useCartStore from '../DataRepo/CartStore';
import { getUserDetails } from '../Auth/AuthUtil';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';

function Wishlist() {

    const navigate = useNavigate()

    const userDetails = getUserDetails()

    const { addItem, cartItems, updateQuantity, decreaseQuantity, removeItem, getCart } = useCartStore();

    const { addWishlist, WishlistItems, isWishlistLoading, removeWishlist, getWishlistItems } = WishlistStore()

    useEffect(() => {
        getWishlistItems()
        getCart()
    }, [])

    const addtoCart = (item, id) => {

        const price = parseInt(item?.price)

        const desc = item?.desc

        const qty = item?.qty

        let product = {
            id: id,
            productName: item?.name,
            quantity: 1,
            price,
            desc,
            companyid: item?.company_id,
            deliverycharges: item?.deliverycharges,
            src: item?.imgurl,
            actualQty: qty,
            sku: item?.sku,
            company: item?.company
        };

        addItem(product, userDetails?.UID)
    }

    return <div className='All-products-section-main'>
        <nav className='flex flex-row p-2'>
            <IconButton onClick={() => navigate(-1)}>
                <ChevronLeft />
            </IconButton>
            <p className='mb-0'>Wishlist</p>
        </nav>
        {isWishlistLoading ?
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100vw", height: '100vh' }}>
                <div style={{ position: "relative", width: "10rem", height: "10rem" }}>
                    <CircularProgress style={{ width: "100%", height: "100%", color: "#DA6E0B" }} thickness={1} />
                    <div style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <img src={loadingimg} style={{ width: "80%", height: "80%" }} alt="Loading" />
                    </div>
                </div>
            </div> :
            WishlistItems?.length > 0 ?
                <div className='wishlist-section'>{
                    WishlistItems?.map((e, i) => (
                        <div key={i} className='Product-section-card' onClick={() => navigate(`/Product?id=${e.id}`)}>
                            <div className="Product-card-header">
                                <div className="Product-discount-badge">
                                    {e.orgprice > 0 && e.orgprice != e.price ? (
                                        <p>
                                            {(((parseFloat(e.orgprice) - parseFloat(e.price)) / parseFloat(e.orgprice)) * 100).toFixed(0) + "% off"}
                                        </p>
                                    ) : null}
                                </div>
                                <div className="Product-wishlist-icon">
                                    <IconButton
                                        onClick={(event) => {
                                            event.stopPropagation();

                                            removeWishlist(e.id)

                                        }}
                                    >
                                        <HighlightOffIcon />
                                    </IconButton>
                                </div>
                            </div>

                            <div>
                                <img src={e.imgurl} alt={e.name} />
                            </div>

                            <div className='Product-section-card-title'>
                                <p>{e?.name}</p>
                                <p>{e?.desc}</p>
                            </div>

                            <div className='Addtobagbutton'>
                                <div className='Product-section-price-details'>
                                    {e?.orgprice > 0 && e?.orgprice != e?.price &&
                                        <p className='mr-5' style={{ fontSize: "16px" }}><del>{`₹ ${e?.orgprice}`}</del></p>}
                                    <p style={{ fontSize: "18px" }}>₹ {e?.price}</p>
                                </div>

                                <div className='w-100'>
                                    <Button
                                        style={{
                                            width: '100%',
                                            display: "block",
                                            textTransform: 'none',
                                            backgroundColor: e?.onsale ? '#75623F' : '#D9d9d9',
                                            color: e?.onsale ? 'white' : "#A5A39D",
                                            border: 'none',
                                            boxSizing: 'border-box',
                                            borderRadius: "5px",
                                            fontFamily: "'Poppins', sans-serif",
                                            fontWeight: 500,
                                            // padding: "5px"
                                        }}
                                        onClick={(event) => {
                                            event.stopPropagation();
                                            const product = e
                                            if (product.onsale) {
                                                const existingItem = cartItems?.find(cartItem => cartItem?.id === product.id);
                                                const id = product?.id
                                                !existingItem && addtoCart(product, id)
                                            }

                                        }}
                                    >
                                        <div className="addtobagctn w-100">
                                            {(() => {
                                                const product = e
                                                if (product.onsale) {
                                                    const existingItem = cartItems?.find(cartItem => cartItem?.id === product.id);
                                                    return (
                                                        <div>
                                                            {existingItem ? (
                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        width: "100%",
                                                                        justifyContent: "space-evenly",
                                                                    }}
                                                                >
                                                                    <RemoveIcon
                                                                        style={{ cursor: "pointer" }}
                                                                        fontSize='small'
                                                                        onClick={(event) => {
                                                                            event.stopPropagation();
                                                                            const product = e
                                                                            const id = product?.id?.toString() || product?.id;

                                                                            existingItem.quantity <= 1 ?
                                                                                removeItem(id) : decreaseQuantity(id, userDetails?.UID);
                                                                        }}
                                                                    />
                                                                    <span>{existingItem.quantity}</span>
                                                                    <AddIcon
                                                                        style={{ cursor: "pointer" }}
                                                                        fontSize='small'
                                                                        onClick={(event) => {
                                                                            event.stopPropagation();
                                                                            const product = e
                                                                            const id =
                                                                                product?.id?.toString() || product?.id;
                                                                            updateQuantity(id, userDetails?.UID);
                                                                        }}
                                                                    />
                                                                </div>
                                                            ) : (
                                                                <p>Add to Bag</p>
                                                            )}
                                                        </div>
                                                    );
                                                } else {
                                                    return <p>Coming Soon</p>;
                                                }
                                            })()}
                                        </div>

                                    </Button>
                                </div>

                            </div>
                        </div>
                    ))
                }
                </div>
                : <div className='EmptyCart'>
                    <img src={nofav}></img>
                    <p>Your Wishlist is Empty.</p>
                    <p>"Explore our products and start adding your favorites to create your personalized wellness collection"</p>
                    <div>
                        <Button
                            style={{
                                width: '100%',
                                textTransform: 'none',
                                backgroundColor: '#FDFDFD',
                                color: '#DA6E0B',
                                border: '1px solid #DA6E0B',
                                boxSizing: 'border-box',
                                borderRadius: "5px",
                                fontFamily: "'Poppins', sans-serif",
                                fontWeight: 500,
                                padding: "10px"
                            }}
                            onClick={() => navigate('/Shop')}
                        >
                            View Products
                        </Button>
                    </div>
                </div>
        }

    </div>
}

export default Wishlist